import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { EntityType } from 'common/enums';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models';
import { PagedRequest } from 'common/models/data/pagedRequest.model';

const archiveApiConfig = {
    getArchivedCategoriesUrl: (pagedRequest: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.ARCHIVED_ENTITIES}`,
            ApiMethods.POST,
            '',
            pagedRequest
        ),
    getEntitiesByIdUrl: (entityId: string, entityType: EntityType): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.ARCHIVED_ENTITIES_BY_ID}/${entityId}`,
            ApiMethods.GET,
            `entityType=${entityType}`
        ),
    deleteArchivedCategory: (id: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.DELETE_ARCHIVED_CATEGORY}/${id}`,
            ApiMethods.PUT
        ),
    deleteArchivedSubCategory: (id: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.DELETE_ARCHIVED_SUB_CATEGORY}/${id}`,
            ApiMethods.PUT
        ),
    deleteArchivedIndicator: (id: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.DELETE_ARCHIVED_INDICATOR}/${id}`,
            ApiMethods.PUT
        ),
    restoreCategoryUrl: (payload: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.RESTORE_CATEGORY}/${payload.id}`,
            ApiMethods.PUT
        ),
    restoreSubCategoryUrl: (payload: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.RESTORE_SUB_CATEGORY}/${payload.id}?targetHierarchyId=${payload.targetId}&isImmediateChild=${payload.isImmediateChild}`,
            ApiMethods.PUT
        ),
    restoreIndicatorUrl: (payload: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.RESTORE_INDICATOR}/${payload.id}?targetHierarchyId=${payload.targetId}`,
            ApiMethods.PUT
        ),
    fetchArchiveListBySearch: (payload: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.ARCHIVE}/${METHOD.ARCHIVE.ARCHIVE_SEARCH}`,
            ApiMethods.POST,
            '',
            payload
        )
};

export default archiveApiConfig;
